// extracted by mini-css-extract-plugin
export default {"wrapper":"PortalNote_wrapper__WUoV6"};